import React from 'react';

import './MarketingMotto.scss';

function MarketingMotto({ motto }) {
  if (!motto) { return null; }

  return <div className="mn_marketingMotto">{motto}</div>;
}

export default MarketingMotto;
